import { createSelector } from 'reselect';

export const appealDomainSelector = state => state.appealFind;

export const appealLoadingSelector = createSelector(
  appealDomainSelector,
  subState => subState.loading
);

export const appealSelector = createSelector(
  appealDomainSelector,
  subState => subState.data || {}
);

export const appealErrorSelector = createSelector(
  appealDomainSelector,
  subState => subState.error
);

export const appealFoundSelector = createSelector(
  appealSelector,
  subState => subState.application
);

export const appealIsApplicantAuthorSelector = createSelector(
  appealSelector,
  subState => subState.author
);

export const appealServiceNumberSelector = createSelector(
  appealSelector,
  subState => subState.service_number
);

export const appealCanBeCanceledSelector = createSelector(
  appealSelector,
  subState => subState.editable
);

export const appealSearchBlocksNextStep = createSelector(
  appealLoadingSelector,
  appealErrorSelector,
  appealFoundSelector,
  (loading, error, found) => loading || error || found === true
);
